import React, { useState, useEffect, useRef } from 'react';
import { Tooltip } from 'react-tooltip';
import { makeid } from './utils.js';
import { IconArrowsMove, IconAdd, IconClose, IconDeleteOutline } from './icons';
import { Form, Button, Modal } from 'react-bootstrap';
import { Option } from './styledcommon'
import { EditableYaml } from './editablelist';
import { ReactSortable } from "react-sortablejs";
import { IconStarSharp } from './icons'
import yaml from 'js-yaml';
import dayjs from 'dayjs';

function useDateInput()
{
    const dateInputDefaults = {
	showInline: false,	// use inline mode.
	disableDates: null, // example: "disable": [ function(date) { /* return true to disable */ return (date.getDay() === 0 || date.getDay() === 6); /* turns off weekdays */ } ],
	altInput: false,    // use friendly format to display
	altFormat: "F j, Y",	// friendly format for display
	dateFormat: 'Y-m-d',
	timeFormat: 'H:i:S',
	timePickerIncr: 5,	// in minutes
	startTime: null,
	endTime: null,
	startFromToday: false,
	range: false,  // mode: "range" for range calendar
	timeRequired: false,
	monthOnly: false, 	// use monthSelectPlugin
    }
    const availDateFormats = [
	['2022-10-07', 'Y-m-d'],
	['10-07-2022', 'm-d-Y'],
	['7-Oct-2022', 'j-M-Y'],
	['7th Oct 2022', 'J M Y'],
	['Oct 07 2022', 'M d Y'],
	['October 7 2022', 'F j Y'],
    ]
    const availTimeFormats = [
	['21:30:23', 'H:i:S'],
	['9:30 PM', 'h:i K'],
	['9:30:23 PM', 'h:i:S K'],
    ]
    function DateOptions({dateProps, setDateProps})
    {
	return (
	    <>
		<div class="mb-4">
		    <label class="form-label">In which format do you want your date?</label>
		    <select class="form-select"
			    value={dateProps.dateFormat}
			    onChange={ev => setDateProps(prev => ({...prev, dateFormat: ev.target.value}))}>
			{availDateFormats.map((arr, key) => <Option key={key} value={arr[1]}>{arr[0]}</Option>)}
		    </select>
		</div>
		<div class="mb-4 d-flex">
		    <Form.Switch id="timeRequiredCheckbox"
				 checked={dateProps.timeRequired}
				 className="d-flex align-items-center"
				 onChange={ev => setDateProps(prev => ({...prev, timeRequired: ev.target.checked}))}/>
		    <label for="timeRequiredCheckbox" className="w-100">
			Ask for time too
		    </label>
		</div>
		{dateProps.timeRequired && (
		    <div class="border rounded p-4">
			<div class="mb-2">
			    <label class="form-label">Time picker minute increment</label>
			    <input type="number"
				   class="form-control"
				   min="1"
				   max="30"
				   step="1"
				   value={dateProps.timePickerIncr}
				   onChange={ev => setDateProps(prev => ({...prev, timePickerIncr: +ev.target.value}))}
				   placeholder="enter increment in minutes"/>
			</div>
			<div class="mb-2 d-flex justify-content-between align-items-center">
			    <label class="form-label">Start time from:</label>
			    <div class="d-flex">
				<select class="form-select me-2"
					value={dateProps.startHour || 0}
					onChange={ev => setDateProps(prev => ({...prev, startHour: +ev.target.value}))}>
				    <Option value="">-- Hour --</Option>
				    {[...Array(24).keys()].map((hour, key) => (
					<Option key={key} value={hour}>{hour}</Option>
				    ))}
				</select>
				<select class="form-select"
					value={dateProps.startMin}
					onChange={ev => setDateProps(prev => ({...prev, startMin: +ev.target.value}))}>
				    <Option value="">-- Min --</Option>
				    {[...Array(Math.floor(60/dateProps.timePickerIncr+(60%dateProps.timePickerIncr>0?1:0))).keys()].map((num, key) => (
					<Option key={key} value={num*dateProps.timePickerIncr}>
					    {num*dateProps.timePickerIncr}
					</Option>
				    ))}
				</select>
			    </div>
			</div>
			<div class="mb-2 d-flex justify-content-between">
			    <label class="form-label">End time at:</label>
			    <div class="d-flex">
				<select class="form-select me-2"
					value={dateProps.endHour}
					onChange={ev => setDateProps(prev => ({...prev, endHour: +ev.target.value}))}>
				    <Option value="">-- Hour --</Option>
				    {[...Array(24).keys()].map((hour, key) => (
					<Option key={key} value={hour}>{hour}</Option>
				    ))}
				</select>
				<select class="form-select"
					value={dateProps.endMin}
					onChange={ev => setDateProps(prev => ({...prev, endMin: +ev.target.value}))}>
				    <Option value="">-- Min --</Option>
				    {[...Array(Math.floor(60/dateProps.timePickerIncr+(60%dateProps.timePickerIncr>0?1:0))).keys()].map((num, key) => (
					<Option key={key} value={num*dateProps.timePickerIncr}>
					    {num*dateProps.timePickerIncr}
					</Option>
				    ))}
				</select>
			    </div>
			</div>
			<div class="mb-2">
			    <label class="form-label">Choose the time format</label>
			    <select class="form-select"
				    value={dateProps.timeFormat}
				    onChange={ev => setDateProps(prev => ({...prev, timeFormat: ev.target.value}))}>
				{availTimeFormats.map((arr, key) => <Option key={key} value={arr[1]}>{arr[0]}</Option>)}
			    </select>
			</div>
		    </div>
		)}
		<div class="mb-4 d-flex">
		    <Form.Switch id="monthOnlyCheckbox"
				 checked={dateProps.monthOnly}
				 className="d-flex align-items-center"
				 onChange={ev => setDateProps(prev => ({...prev, monthOnly: ev.target.checked}))}/>
		    <label for="monthOnlyCheckbox" className="w-100">
			Select month only
		    </label>
		</div>
		<div class="mb-4 d-flex">
		    <Form.Switch id="rangeCheckbox"
				 checked={dateProps.range}
				 className="d-flex align-items-center"
				 onChange={ev => setDateProps(prev => ({...prev, range: ev.target.checked}))}/>
		    <label for="rangeCheckbox" className="w-100">
			Allow range selection
		    </label>
		</div>
		<div class="mb-4 d-flex">
		    <Form.Switch id="startFromTodayCheckbox"
				 checked={dateProps.startFromToday}
				 className="d-flex align-items-center"
				 onChange={ev => setDateProps(prev => ({...prev, startFromToday: ev.target.checked}))}/>
		    <label for="startFromTodayCheckbox" className="w-100">
			Start from today ("today" is when the form is filled)
		    </label>
		</div>
	    </>
	)
    }
    return { dateInputDefaults, DateOptions }
}

const dateDropdownDefaults = {
    dayLabel: 'Day',
    monthLabel: 'Month',
    yearLabel: 'Year',
    yearStart: 1900,
    numYears: 200,
    monthNames: ['January', 'February', 'March', 'April',
		 'May', 'June', 'July', 'August', 'September',
		 'October', 'November', 'December'],
    dateFormats: [{value: 'MM/DD/YYYY', label: '01/03/1982'},
		  {value: 'MMM-DD-YYYY', label: 'Jan-07-1982'},
		  {value: 'MMMM DD YYYY', label: 'January 07 1982'},
		  {value: 'M/D/YYYY', label: '1/7/1982'},
		  {value: 'MMM D YYYY', label: 'Jan 7 1982'},
		  {value: 'MMMM D YYYY', label: 'January 7 1982'},
		  {value: 'DD/MM/YYYY', label: '07/01/1982'},
		  {value: 'DD-MMM-YYYY', label: '07-Jan-1982'},
		  {value: 'DD MMMM YYYY', label: '07 January 1982'},
		  {value: 'D/M/YYYY', label: '7/1/1982'},
		  {value: 'D MMM YYYY', label: '7 Jan 1982'},
		  {value: 'D MMMM YYYY', label: '7 January 1982'}],
    selectedDateFormat: {value: 'MMM-DD-YYYY', label: 'Jan-07-1982'},
    showCurrentDate: true,
    validRange: false,
    validStart: [null, 'days', 'before'],
    validEnd: [null, 'days', 'before']
}

function DateDropdownOptions({widgetProps, setWidgetProps})
{
    return (
	<>
	    <div class="mb-4 d-flex">
		<Form.Switch id="showCurrentDateCheckbox"
			     checked={widgetProps.showCurrentDate}
			     className="d-flex align-items-center"
			     onChange={ev => setWidgetProps(prev => ({...prev,
								      showCurrentDate: ev.target.checked}))}/>
		<label for="showCurrentDateCheckbox" className="w-100">
		    Default to current date
		</label>
	    </div>
	    <div class="mb-2 d-flex">
		<Form.Switch id="validRangeCheckbox"
			     checked={widgetProps.validRange}
			     onChange={ev => setWidgetProps(prev => ({...prev, validRange: ev.target.checked}))}
			     className="d-flex align-items-center"/>
		<label for="validRangeCheckbox" className="w-100">
		    Specify a valid date range
		</label>
	    </div>
	    {widgetProps.validRange && (
		<>
		    <div class="mb-2">
			<label class="form-label">Date must start: </label>
			<div class="mb-2 d-flex justify-content-between align-items-center">
			    <input type="number"
				   class="form-control"
				   min="0"
				   value={widgetProps.validStart[0]}
				   onChange={ev => {
				       if ( !Number.isNaN(parseInt(ev.target.value)) )
					   setWidgetProps(prev => ({...prev,
								    validStart: [+ev.target.value,
										 prev.validStart[1],
										 prev.validStart[2]]}))
				   }}/>
			    <select class="form-select"
				    value={widgetProps.validStart[1]}
				    onChange={ev => {
					setWidgetProps(prev => ({...prev,
								 validStart: [prev.validStart[0],
									      ev.target.value,
									      prev.validStart[2]]}))
				    }}>
				<Option value="day">days</Option>
				<Option value="month">months</Option>
				<Option value="year">years</Option>
			    </select>
			    <select class="form-select"
				    value={widgetProps.validStart[2]}
				    onChange={ev => {
					setWidgetProps(prev => ({...prev,
								 validStart: [prev.validStart[0],
									      prev.validStart[1],
									      ev.target.value]}))
				    }}>>
				<Option>before</Option>
				<Option>after</Option>
			    </select>
			</div>
		    </div>
		    <div class="mb-4">
			<label class="form-label">Date must end: </label>
			<div class="mb-2 d-flex justify-content-between align-items-center">
			    <input type="number"
				   class="form-control"
				   min="0"
				   value={widgetProps.validEnd[0]}
				   onChange={ev => {
				       if ( !Number.isNaN(parseInt(ev.target.value)) )
					   setWidgetProps(prev => ({...prev,
								    validEnd: [+ev.target.value,
									       prev.validEnd[1],
									       prev.validEnd[2]]}))
				   }}/>
			    <select class="form-select"
				    value={widgetProps.validEnd[1]}
				    onChange={ev => {
					setWidgetProps(prev => ({...prev,
								 validEnd: [prev.validEnd[0],
									    ev.target.value,
									    prev.validEnd[2]]}))
				    }}>
				<Option value="day">days</Option>
				<Option value="month">months</Option>
				<Option value="year">years</Option>
			    </select>
			    <select class="form-select"
				    value={widgetProps.validEnd[2]}
				    onChange={ev => {
					setWidgetProps(prev => ({...prev,
								 validEnd: [prev.validEnd[0],
									    prev.validEnd[1],
									    ev.target.value]}))
				    }}>
				<Option>before</Option>
				<Option>after</Option>
			    </select>
			</div>
		    </div>
		</>
	    )}
	    <div class="mb-2">
		<label class="form-label">Enter day label</label>
		<input type="text"
		       class="form-control"
		       value={widgetProps.dayLabel}
		       onChange={ev => setWidgetProps(prev => ({...prev, dayLabel: ev.target.value}))}/>
	    </div>
	    <div class="mb-2">
		<label class="form-label">Enter month label</label>
		<input type="text"
		       class="form-control"
		       value={widgetProps.monthLabel}
		       onChange={ev => setWidgetProps(prev => ({...prev, monthLabel: ev.target.value}))}/>
	    </div>
	    <div class="mb-4">
		<label class="form-label">Enter year label</label>
		<input type="text"
		       class="form-control"
		       value={widgetProps.yearLabel}
		       onChange={ev => setWidgetProps(prev => ({...prev, yearLabel: ev.target.value}))}/>
	    </div>
	    <div class="mb-4">
		<label class="form-label">Date format</label>
		<select class="form-select"
			value={widgetProps.selectedDateFormat}
			onChange={ev => setWidgetProps(prev => ({...prev,
								 selectedDateFormat: ev.target.value}))}>
		    {widgetProps.dateFormats.map((df, dfi) => <Option value={df.value}>{df.label}</Option>)}
		</select>
	    </div>
	</>
    )
}

function MoreInput({setShowModal, commonProps, setCommonProps, editColumnId})
{
    const [name, setName] = useState(''),
	  [inputtype, setInputtype] = useState(''),
	  [inputopts, setInputOpts] = useState({}),
	  [choices, setChoices] = useState([]),
	  [choiceYaml, setChoiceYaml] = useState(''),
	  {dateInputDefaults, DateOptions} = useDateInput(),
	  mapDataType = inputtype => {
	      switch(inputtype) {
	      case 'Text':
	      case 'Long Text':
	      case 'Email':
		  return 'string'
	      case 'Integer':
	      case 'Float':
	      case 'Range':
		  return 'number';
	      case 'Dropdown':
		  return 'enumlist';
	      case 'Date':
		  return 'datetime'
	      case 'Date Dropdown':
		  return 'date'
	      }
	  },
	  saveInputDefn = ev => {
	      const inputdef = {
		  name: name,
		  label: name,
		  type: inputtype,
		  dataType: mapDataType(inputtype),
		  id: editColumnId,
		  inputopts: {...inputopts}
	      }
	      setCommonProps(prev => {
		  if ( 'moreInputs' in prev && prev.moreInputs ) {
		      const index = prev.moreInputs.findIndex(x => x.id === editColumnId)
		      if ( index === -1 ) {
			  return {...prev, moreInputs: [...prev.moreInputs, inputdef]}
		      } else {
			  return {...prev, moreInputs: [...prev.moreInputs.slice(0, index),
							inputdef,
							...prev.moreInputs.slice(index+1)]}
		      }
		  } else {
		      return {...prev, moreInputs: [inputdef]}
		  }
	      })
	      setShowModal(false)
	  }
    useState(() => {
	if ( commonProps ) {
	    const index = 'moreInputs' in commonProps && commonProps.moreInputs ?
		  commonProps.moreInputs.findIndex(c => c.id === editColumnId) : -1
	    if ( index === -1 ) {
		setName('')
		setInputtype('')
		setInputOpts({})
		setChoices([])
		setChoiceYaml('')
	    } else {
		const inputdef = {...commonProps.moreInputs[index]}
		setName(inputdef.name)
		setInputtype(inputdef.type)
		setChoices('choices' in inputdef ? inputdef.choices : [])
		setChoiceYaml('choiceYaml' in inputdef ? inputdef.choiceYaml : '')
		setInputOpts('inputopts' in inputdef ? inputdef.inputopts : {})
	    }
	}
    }, [editColumnId])
    return (
	<>
	    <Modal show={true} onHide={ev => setShowModal(false)}>
		<Modal.Header closeButton>
		    <Modal.Title>Add or Edit Input</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		    <div class="mb-2">
			<label class="form-label">Input Label</label>
			<input type="text"
			       class="form-control"
			       value={name}
			       onChange={ev => setName(ev.target.value)}/>
		    </div>
		    <div class="mb-2">
			<label class="form-label">Input type</label>
			<select class="form-select"
				value={inputtype}
				onChange={ev => {
				    const type = ev.target.value
				    setInputtype(type)
				    if ( type === 'Text' ) setInputOpts({valueRequired: true})
				    else if ( type === 'Long Text' ) setInputOpts({
					valueRequired: true,
					visibleRows: 4,
				    })
				    else if ( type === 'Date Dropdown' ) {
					setInputOpts({...dateDropdownDefaults})
				    }
				}}>
			    <Option value="">-- Choose --</Option>
			    <Option>Text</Option>
			    <Option>Email</Option>
			    <Option>Long Text</Option>
			    <Option>Integer</Option>
			    <Option>Float</Option>
			    <Option>Dropdown</Option>
			    <Option>Range</Option>
			    <Option>Date</Option>
			    <Option>Date Dropdown</Option>
			</select>
		    </div>
		    {inputtype && inputtype !== 'Checkbox' && (
			<div class="mt-4 mb-2 d-flex">
			    <Form.Switch id="requiredCheckboxMoreInput"
					 checked={inputopts.valueRequired}
					 className="d-flex align-items-center"
					 onChange={ev => setInputOpts(prev => ({...prev,
										valueRequired: ev.target.checked}))}/>
			    <label htmlFor="requiredCheckboxMoreInput" className="w-100">
				Value is required
			    </label>
			</div>
		    )}
		    {inputtype === 'Checkbox' && (
			<div class="mt-4 mb-2 d-flex">
			    <Form.Switch id="defaultCheckedCheckbox"
					 checked={inputopts.defaultChecked}
					 className="d-flex align-items-center"
					 onChange={ev => setInputOpts(prev => ({...prev,
										defaultChecked: ev.target.checked}))}/>
			    <label htmlFor="defaultCheckedCheckbox" className="w-100">
				Default checked
			    </label>
			</div>
		    )}
		    {(inputtype === 'Text' || inputtype === 'Long Text') && (
			<div class="mb-2">
			    <label className="form-label">Maximum size</label>
			    <input type="text"
				   class="form-control"
				   value={inputopts.maxChars}
				   onChange={ev => {
				       const v = +ev.target.value
				       if ( String(v) === ev.target.value )
					   setInputOpts(prev => ({...prev, maxChars: v}))
				   }}/>
			</div>
		    )}
		    {(inputtype === 'Long Text') && (
			<div class="mb-2">
			    <label className="form-label">Number of visible rows</label>
			    <input type="number"
				   class="form-control"
				   value={inputopts.visibleRows || 4}
				   onChange={ev => {
				       const v = +ev.target.value
				       if ( String(v) === ev.target.value )
					   setInputOpts(prev => ({...prev, visibleRows: v}))
				   }}/>
			</div>
		    )}
		    {(inputtype === 'Integer' || inputtype === 'Range' || inputtype === 'Float') && (
			<div class="d-flex justify-content-between gap-1">
			    <div class="mb-2">
				<label className="form-label">Minimum</label>
				<input type="text"
				       class="form-control"
				       size="10"
				       value={inputopts.minValue}
				       onChange={ev => {
					   const v = +ev.target.value
					   if ( String(v) === ev.target.value &&
						(('maxValue' in inputopts && v < inputopts.maxValue) ||
						 !('maxValue' in inputopts)) )
					       setInputOpts(prev => ({...prev, minValue: v}))
				       }}/>
				<div class="form-text">Leave empty if no minimum</div>
			    </div>
			    <div class="mb-2">
				<label className="form-label">Maximum</label>
				<input type="text"
				       class="form-control"
				       size="10"
				       value={inputopts.maxValue}
				       onChange={ev => {
					   const v = +ev.target.value
					   if ( String(v) === ev.target.value &&
						(('minValue' in inputopts && v > inputopts.minValue) ||
						 !('minValue' in inputopts)) )
					       setInputOpts(prev => ({...prev, maxValue: v}))
				       }}/>
				<div class="form-text">Leave empty if no maximum</div>
			    </div>
			</div>
		    )}
		    {inputtype === 'Dropdown' && (
			<div class="mb-2">
			    <label class="form-label">Enter items below.</label>
			    <EditableYaml choices={inputopts.choices}
					  setChoices={x => setInputOpts(prev => ({...prev, choices: x}))}
					  choiceYaml={inputopts.choiceYaml}
					  setChoiceYaml={x => setInputOpts(prev => ({...prev, choiceYaml: x}))}/>
			</div>
		    )}
		    {inputtype === 'Date' && (
			<>
			    <DateOptions dateProps={{...dateInputDefaults, ...inputopts}}
					 setDateProps={setInputOpts}/>
			</>
		    )}
		    {inputtype === 'Date Dropdown' && (
			<>
			    <DateDropdownOptions widgetProps={{...dateDropdownDefaults, ...inputopts}}
						 setWidgetProps={setInputOpts}/>
			</>
		    )}
		</Modal.Body>
		<Modal.Footer>
		    <Button variant="secondary" onClick={ev => setShowModal(false)}>
			Close
		    </Button>
		    <Button variant="primary"
			    className="d-flex align-items-center"
			    disabled={!(name && inputtype && inputopts)}
			    onClick={saveInputDefn}>
			Save
		    </Button>
		</Modal.Footer>
	    </Modal>
	</>
    )
}

export function MoreInputsBlock({commonProps, setCommonProps, steps, currentStep})
{
    const [editColumnId, setEditColumnId] = useState(''),
	  [showModal, setShowModal] = useState(false),
	  tooltipRef = useRef(null)
   return (
	<>
	    <table className="table table-striped">
		<thead>
		    <tr>
			<th>#</th>
			<th>Label</th>
			<th>Type</th>
			<th>Options</th>
		    </tr>
		</thead>
		{'moreInputs' in commonProps && commonProps.moreInputs && (
		    <ReactSortable tag="tbody"
				   list={commonProps.moreInputs}
				   setList={cols => {
				       setCommonProps(prev => ({...prev, moreInputs: cols}))
				   }}
				   handle=".handle"
				   animation={250}>
			{commonProps.moreInputs.map((input, ii) => (
			    <tr key={ii}>
				<td>
				    <div class="d-flex align-items-center gap-2">
					<IconArrowsMove className="handle"
							style={{cursor: 'grab'}}
							width="0.8rem"
							height="0.8rem"/>
					<a className="nolink"
					   onClick={ev => {
					       setEditColumnId(input.id)
					       setShowModal(true)
					   }}>{ii+1}</a>
					<a className="nolink"
					   data-input-no={ii}
					   data-tooltip-id="deleteInputTooltip">
					    <IconClose className="text-danger" width="1rem" height="1rem"/>
					</a>
				    </div>
				</td>
				<td>{input.name}</td>
				<td>{input.type}</td>
				<td>{input.options}</td>
			    </tr>
			))}
		    </ReactSortable>
		)}
		<Tooltip id="deleteInputTooltip"
			 ref={tooltipRef}
			 style={{padding: 0, zIndex: 100}}
			 clickable
			 openOnClick={true}
			 render={({content, activeAnchor}) => {
			     const cno = Number(activeAnchor?.getAttribute('data-input-no'))
			     return (
				 <div class="p-4 rounded"
				      style={{backgroundColor: '#ddd', color: '#000'}}>
				     <div class="mb-2">
					 <div>Are you sure you want to delete this field?</div>
				     </div>
				     <div class="d-flex justify-content-between">
					 <button class="btn btn-secondary"
						 onClick={ev => tooltipRef.current?.close()}>
					     <IconClose/> Close
					 </button>
					 <button class="btn btn-danger"
						 onClick={ev => {
						     setCommonProps(prev => ({...prev,
									      moreInputs: [...prev.moreInputs.slice(0, cno), ...prev.moreInputs.slice(cno+1)]}))
						     tooltipRef.current?.close()
						 }}>
					     <IconDeleteOutline/> Delete
					 </button>
				     </div>
				 </div>
			     )
			 }}/>
	    </table>
	    <button type="button"
		    className="btn btn-info"
		    onClick={ev => {
			setEditColumnId(makeid(8))
			setShowModal(true)
		    }}>
		<IconAdd /> Add input
	    </button>
	    {editColumnId && showModal && (
		<MoreInput setShowModal={setShowModal}
			   commonProps={commonProps}
			   setCommonProps={setCommonProps}
			   editColumnId={editColumnId}/>
	    )}
	</>
    )
}

export function TextDemo({inputdef})
{
    return (
	<>
	    <div class="mb-2">
		<label class="form-label d-flex align-items-center">
		    {inputdef.name}
		    {inputdef.inputopts.valueRequired && (
			<IconStarSharp height="0.8rem" width="0.8rem" className="ms-2"/>
		    )}
		</label>
		<input className="form-control"
		       name={inputdef.id}
		       type="text"
		       required={inputdef.inputopts.valueRequired}/>
	    </div>
	</>
    )
}

export function LongTextDemo({inputdef})
{
    return (
	<>
	    <div class="mb-2">
		<label class="form-label d-flex align-items-center">
		    {inputdef.name}
		    {inputdef.inputopts.valueRequired && (
			<IconStarSharp height="0.8rem" width="0.8rem" className="ms-2"/>
		    )}
		</label>
		<textarea class="form-control"
			  autofocus
			  maxlength={inputdef.inputopts.maxLength}
			  rows={inputdef.inputopts.visibleRows}/>
	    </div>
	</>
    )
}

export function NumberDemo({inputdef})
{
    return (
	<>
	    <div class="mb-2">
		<label class="form-label d-flex align-items-center">
		    {inputdef.name}
		    {inputdef.inputopts.valueRequired && (
			<IconStarSharp height="0.8rem" width="0.8rem" className="ms-2"/>
		    )}
		</label>
		<input className="form-control"
		       name={inputdef.id}
		       type="number"
		       min={inputdef.inputopts.minValue}
		       max={inputdef.inputopts.maxValue}
		       required={'valueRequired' in inputdef.inputopts ?
				 inputdef.inputopts.valueRequired : false}/>
	    </div>
	</>
    )
}

export function DateDropdownDemo({inputdef})
{
    const commonProps = inputdef.inputopts,
	  today = new Date(),
	  [day, setDay] = useState(commonProps.showCurrentDate ? {
	      label: today.getDate(),
	      value: today.getDate()
	  }: null),
	  [month, setMonth] = useState(commonProps.showCurrentDate ? {
	      label: commonProps.monthNames[today.getMonth()],
	      value: commonProps.monthNames[today.getMonth()]
	  }: null),
	  [year, setYear] = useState(commonProps.showCurrentDate ? {
	      label: today.getFullYear(),
	      value: today.getFullYear(),
	  }: null),
	  [displayStr, setDisplayStr] = useState('')
    useEffect(() => {
	if ( month && day && year ) {
	    const dateStr = `${day.value} ${month.value} ${year.value}`
	    setDisplayStr(dayjs(dateStr, 'D MMMM YYYY').format(commonProps.selectedDateFormat.value))
	}
    }, [month, day, year, commonProps.selectedDateFormat])
    useEffect(() => {
	setDay(commonProps.showCurrentDate ? {
	    label: today.getDate(),
	    value: today.getDate()
	}: null)
	setMonth(commonProps.showCurrentDate ? {
	    label: commonProps.monthNames[today.getMonth()],
	    value: commonProps.monthNames[today.getMonth()]
	}: null)
	setYear(commonProps.showCurrentDate ? {
	    label: today.getFullYear(),
	    value: today.getFullYear(),
	}: null)
    }, [commonProps.showCurrentDate])
    return (
	<>
	    <div class="row">
		<div class="col-12">
		    <label class="form-label d-flex align-items-center">
			{inputdef.name}
			{inputdef.inputopts.valueRequired && (
			    <IconStarSharp height="0.8rem" width="0.8rem" className="ms-2"/>
			)}
		    </label>
		</div>
	    </div>
	    <div class="row">
		<div class="col-4">
		    <label class="form-label">{commonProps.dayLabel}</label>
		    <select class="form-select"
			    value={day}
			    onChange={ev => setDay(+ev.target.value)}>
			<Option value="">-- Select --</Option>
			{[...Array(31).keys()].map((x, xi) => <Option>{x+1}</Option>)}
		    </select>
		</div>
		<div class="col-4">
		    <label class="form-label">{commonProps.monthLabel}</label>
		    <select class="form-select"
			    value={month}
			    onChange={ev => setMonth(+ev.target.value)}>
			<Option value="">-- Select --</Option>
			{commonProps.monthNames.map((name, ni) => <Option>{name}</Option>)}
		    </select>
		</div>
		<div class="col-4">
		    <label class="form-label">{commonProps.yearLabel}</label>
		    <select class="form-select"
			    value={year}
			    onChange={ev => setYear(+ev.target.value)}>
			<Option value="">-- Select --</Option>
			{[...Array(commonProps.numYears+1).keys()]
			 .map(x => x + commonProps.yearStart)
			 .map(x => <Option>{x}</Option>)}
		    </select>
		</div>
	    </div>
	    {displayStr && (
		<div class="form-text"><span class="me-2">Selected date is:</span><span>{displayStr}</span></div>
	    )}
	</>
    )
}

export function DropdownDemo({inputdef})
{
    return (
	<>
	    <div class="mb-2">
		<label class="form-label d-flex align-items-center">
		    {inputdef.name}
		    {inputdef.inputopts.valueRequired && (
			<IconStarSharp height="0.8rem" width="0.8rem" className="ms-2"/>
		    )}
		</label>
		<select class="form-select">
		    <Option value="">-- Select --</Option>
		    {inputdef.inputopts.choices.map((choice, ci) => <Option>{choice}</Option>)}
		</select>
	    </div>
	</>
    )
}

function TextField({inputdef, ...inputProps})
{
    return (
	<>
	    <div class="mb-2">
		<label class="form-label tertiary-text">{inputdef.name}</label>
		<input className="form-control"
		       name={inputdef.id}
		       type="text"
		       required={inputdef.inputopts.valueRequired}
		       {...inputProps}/>
	    </div>
	</>
    )
}

function LongTextField({inputdef, ...inputProps})
{
    return (
	<>
	    <div class="mb-2">
		<label class="form-label tertiary-text">{inputdef.name}</label>
		<textarea class="form-control"
			  name={inputdef.id}
			  maxlength={inputdef.inputopts.maxLength}
			  rows={inputdef.inputopts.visibleRows}
			  {...inputProps}/>
	    </div>
	</>
    )
}

function DropdownField({inputdef, ...inputProps})
{
    const [tree, setTree] = useState([]),
	  verifyYaml = yamlStr => {
	      try {
		  const doc = yaml.load(inputdef.inputopts.choiceYaml)
		  if ( doc && doc.constructor === Object ) {
		      const result = {}
		      Object.keys(doc).map((key, ki) => {
			  const val = doc[key]
			  if ( val.constructor === Array ) result[key] = val
		      })
		      if ( Object.keys(result).length > 0 ) setTree(result)
		  }
	      } catch(ex) {
		  console.log('unable to parse yaml: %O [%O] ... ignored', inputdef.inputopts.choiceYaml, ex)
	      }
	  }
    useEffect(() => {
	if ( 'choiceYaml' in inputdef.inputopts && inputdef.inputopts.choiceYaml.length > 0 ) {
	    verifyYaml(inputdef.inputopts.choiceYaml)
	}
    }, [inputdef])
    return (
	<>
	    <label class="form-label tertiary-text">{inputdef.name}</label>
	    {Object.keys(tree).length > 0 ? (
		<select class="form-select"
			name={inputdef.id}
			{...inputProps}>
		    <Option value="">-- Select --</Option>
		    {Object.keys(tree).map((key, ki) => (
			<optgroup key={ki} label={key}>
			    {tree[key].map((item, ii) => (
				<Option>{item}</Option>
			    ))}
			</optgroup>
		    ))}
		</select>
	    ) : (
		<select class="form-select"
			name={inputdef.id}
			{...inputProps}>
		    <Option value="">-- Select --</Option>
		    {inputdef.inputopts.choices.map((choice, ci) => (
			<Option>{choice}</Option>
		    ))}
		</select>
	    )}
	</>
    )
}

function NumberField({inputdef, ...inputProps})
{
    return (
	<>
	    <div class="mb-2">
		<label class="form-label tertiary-text d-flex align-items-center">
		    {inputdef.name}
		    {inputdef.inputopts.valueRequired && (
			<IconStarSharp height="0.8rem" width="0.8rem" className="ms-2"/>
		    )}
		</label>
		<input className="form-control"
		       type="number"
		       name={inputdef.id}
		       min={inputdef.inputopts.minValue}
		       max={inputdef.inputopts.maxValue}
		       required={'valueRequired' in inputdef.inputopts ?
				 inputdef.inputopts.valueRequired : false}
		       {...inputProps}/>
	    </div>
	</>
    )
}

function DateDropdownField({inputdef, ...inputProps})
{
    const today = new Date(),
	  commonProps = {...inputdef.inputopts},
	  [day, setDay] = useState(null),
	  [month, setMonth] = useState(null),
	  [year, setYear] = useState(null),
	  [displayStr, setDisplayStr] = useState(''),
	  [corrected, setCorrected] = useState(false),
	  [startDate, setStartDate] = useState(null),
	  [endDate, setEndDate] = useState(null),
	  [errorMessage, setErrorMessage] = useState('')
    useEffect(() => {
	if ( commonProps.showCurrentDate ) {
	    setDay(today.getDate())
	    setMonth(commonProps.monthNames[today.getMonth()])
	    setYear(today.getFullYear())
	}
	if ( commonProps.validRange ) {
	    let start, end;
	    if ( commonProps.validStart &&
		 commonProps.validStart.length === 3 &&
		 commonProps.validStart[0] !== null) {
		const today = dayjs()
		start = (commonProps.validStart[2] === 'before' ?
			 today.subtract(commonProps.validStart[0], commonProps.validStart[1]) :
			 today.add(commonProps.validStart[0], commonProps.validStart[1]))
	    }
	    if ( commonProps.validEnd &&
		 commonProps.validEnd.length === 3 &&
		 commonProps.validEnd[0] !== null) {
		const today = dayjs()
		end = (commonProps.validEnd[2] === 'before' ?
		       today.subtract(commonProps.validEnd[0], commonProps.validEnd[1]) :
		       today.add(commonProps.validEnd[0], commonProps.validEnd[1]))
	    }
	    if ( start > end ) {
		console.error('Valid start date %O is after valid end date',
			      start.format(commonProps.selectedDateFormat.value),
			      end.format(commonProps.selectedDateFormat.value))
		setStartDate(null)
		setEndDate(null)
	    } else {
		setStartDate(start)
		setEndDate(end)
	    }
	}
    }, [commonProps])
    useEffect(() => {
	if ( month && day && year ) {
	    const dateStr = `${day} ${month} ${year}`,
		  date = dayjs(dateStr, 'D MMMM YYYY')
	    inputProps.onChange('')
	    if ( 'validRange' in commonProps && commonProps.validRange ) {
		if ( 'validStart' in commonProps && commonProps.validStart[0] !== null ) {
		    if ( !date.isAfter(startDate) ) {
			setErrorMessage(`Date must be after ${startDate.format(commonProps.selectedDateFormat.value)}`)
			return
		    }
		}
		if ( 'validEnd' in commonProps && commonProps.validEnd[0] !== null ) {
		    if ( !date.isBefore(endDate) ) {
			setErrorMessage(`Date must be before ${endDate.format(commonProps.selectedDateFormat.value)}`)
			return
		    }
		}
	    }
	    setErrorMessage('')
	    const mon = commonProps.monthNames.findIndex(x => x === month)
	    setCorrected(false)
	    if ( day != date.get('D') ) {
		setDay(date.get('D'))
		setCorrected(true)
	    }
	    if ( mon != date.get('M') ) {
		const mname = commonProps.monthNames[date.get('M')]
		setMonth(mname)
		setCorrected(true)
	    }
	    if ( year != date.get('y') ) {
		setYear(date.get('y'))
		setCorrected(true)
	    }
	    setDisplayStr(date.format(commonProps.selectedDateFormat.value))
	    inputProps.onChange(date.format(commonProps.selectedDateFormat.value))
	}
    }, [month, day, year])
    window.gdd = (day, mno, year) => { // function for setting values from global javascript - used by selenium
	setDay(day)
	const mname = commonProps.monthNames[mno]
	setMonth(mname)
	setYear(year)
    }
    return (
	<>
	    {commonProps ? (
		<>
		    <input type="hidden" name={inputdef.id} value={displayStr}/>
		    <div class="row">
			<div class="col-12">
			    <label class="form-label tertiary-text d-flex align-items-center">
				{inputdef.name}
				{inputdef.inputopts.valueRequired && (
				    <IconStarSharp height="0.8rem" width="0.8rem" className="ms-2"/>
				)}
			    </label>
			</div>
		    </div>
		    <div class="row">
			<div class="col-12 col-xl-4">
			    <label class="form-label tertiary-text">{commonProps.dayLabel}</label>
			    <select class="form-select"
				    value={day}
				    onChange={ev => setDay(+ev.target.value)}>
				<Option value="">-- Select --</Option>
				{[...Array(31).keys()].map((x, xi) => <Option>{x+1}</Option>)}
			    </select>
			</div>
			<div class="col-12 col-xl-4">
			    <label class="form-label tertiary-text">{commonProps.monthLabel}</label>
			    <select class="form-select"
				    value={month}
				    onChange={ev => setMonth(ev.target.value)}>
				<Option value="">-- Select --</Option>
				{commonProps.monthNames.map((name, ni) => <Option>{name}</Option>)}
			    </select>
			</div>
			<div class="col-12 col-xl-4">
			    <label class="form-label tertiary-text">{commonProps.yearLabel}</label>
			    <select class="form-select"
				    value={year}
				    onChange={ev => setYear(+ev.target.value)}>
				<Option value="">-- Select --</Option>
				{[...Array(commonProps.numYears+1).keys()]
				 .map(x => x + commonProps.yearStart)
				 .map(x => <Option>{x}</Option>)}
			    </select>
			</div>
		    </div>
		</>
	    ) : (
		<div class="spinner-border text-secondary" role="status">
		    <span class="visually-hidden">Loading...</span>
		</div>
	    )}
	    {displayStr && (
		<div class="form-text tertiary-text">
		    <span class="me-2">Selected date is:</span>
		    <span>{displayStr} {corrected && 'corrected'}</span>
		</div>
	    )}
	    {errorMessage && (
		<div class="form-text tertiary-text">
		    <span>{errorMessage}</span>
		</div>
	    )}
	</>
    )
}

export function MoreInputFields({step, setValidated})
{
    const [values, setValues] = useState({})
    useEffect(() => {
	if ( ! step ) return
	if ( !('moreInputs' in step) ) return
	let validated = true
	step.moreInputs.forEach((inputdef, ii) => {
	    if ( inputdef.inputopts.valueRequired ) {
		if ( !(inputdef.id in values) ) {
		    validated = false
		    return
		}
		if ( values[inputdef.id] === null || values[inputdef.id] === undefined ) {
		    validated = false
		    return
		}
		if ( new String(values[inputdef.id]).length == 0 ) {
		    validated = false
		    return
		}
	    }
	})
	console.log('values = %O, validated = %O', values, validated);
	setValidated(validated)
    }, [step, values])
    return step && 'moreInputs' in step && step.moreInputs.map((input, ii) => (
	<div key={ii}>
	    {input.type === 'Text' && <TextField inputdef={input}
						 value={values[input.id]}
						 onChange={ev => {
						     setValues(prev => ({...prev, [input.id]: ev.target.value}))
						 }}/>}
	    {input.type === 'Long Text' && <LongTextField inputdef={input}
							  value={values[input.id]}
							  onChange={ev => {
							      setValues(prev => ({...prev,
										  [input.id]: ev.target.value}))
							  }}/>}
	    {input.type === 'Dropdown' && <DropdownField inputdef={input}
							 value={values[input.id]}
							 onChange={ev => {
							     setValues(prev => ({...prev,
										 [input.id]: ev.target.value}))
							 }}/>}
	    {input.type === 'Integer' && <NumberField inputdef={input}
						      value={values[input.id]}
						      onChange={ev => {
							  setValues(prev => ({...prev,
									      [input.id]: +ev.target.value}))
						      }}/>}
	    {input.type === 'Date Dropdown' && <DateDropdownField inputdef={input}
								  onChange={dateStr => {
								      setValues(prev => ({...prev,
											  [input.id]: dateStr}))
								  }}/>}
	    <div class="mb-3"></div>
	</div>
    ))
}

export function updateDataFields(moreInputs, dataFields)
{
    if ( ! moreInputs ) return [...dataFields.filter(x => !('source' in x))]
    else
	return [...dataFields.filter(x => !('source' in x)),
		moreInputs.map(inputdef => ({id: inputdef.id,
					     name: inputdef.name,
					     label: inputdef.name,
					     type: inputdef.type,
					     source: 'moreInputs',
					     dataType: inputdef.dataType}))].flat()
}
